import React from "react";

export default function FormBody(props: {
  children: React.ReactNode;
}): JSX.Element {
  return <div>{props.children}</div>;
}
